import React, {Component} from 'react';
import './PostJob.css';
import Header from '../Layout/Header';
import { Helmet } from 'react-helmet';

class PostJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedPlan: null,
        };
        
        this.plans = [
            {
                id: 1,
                name: "Post Job Simple",
                price: "49",
                features: [
                    "1 job posting",
                    "30 days visibility",
                    "Standard job listing",
                    "Promotion across multiple channels",
                    "Email support",
                ]
            },
            {
                id: 2,
                name: "Post Job Featured",
                price: "99",
                features: [
                    "1 job posting",
                    "30 days visibility",
                    "Highlighted job listing with special color",
                    "Promotion across multiple channels",
                    "Sticky position at top of home page",
                    "Priority placement in search results",
                    "Email support",
                ]
            }
        ];
    }

    handleSelectPlan = (planId) => {
        this.setState({ selectedPlan: planId });
        
        // Redireccionar según el plan seleccionado
        if (planId === 1) {
            window.open('https://maurobonfietti.gumroad.com/l/post-job-simple', '_blank');
        } else if (planId === 2) {
            window.open('https://maurobonfietti.gumroad.com/l/post-job-featured', '_blank');
        }
    }

    scrollToPlans = () => {
        document.querySelector('.pricing-cards').scrollIntoView({ 
            behavior: 'smooth',
            block: 'center'
        });
    };

    componentDidMount() {
        // No cargar Tawk.to en localhost
        if (window.location.hostname !== 'localhost' && !window.location.hostname.includes('127.0.0.1')) {
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_LoadStart = new Date();
            (function(){
                var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
                s1.async=true;
                s1.src='https://embed.tawk.to/64f3f113b2d3e13950ed976c/1h9cebdgr';
                s1.charset='UTF-8';
                s1.setAttribute('crossorigin','*');
                s0.parentNode.insertBefore(s1,s0);
            })();
        }
    }

    componentWillUnmount() {
        // Remover el script de Tawk.to cuando el componente se desmonte
        const tawkScript = document.querySelector('script[src*="tawk.to"]');
        if (tawkScript) {
            tawkScript.remove();
        }
    }

    render() {
        return (
            <>

                <Helmet>
                    <title>Post your Job in our website</title>
                    <meta name="description" content="Post your job in our website and connect with top talent. Find the perfect candidate for your remote job opening." />
                    <link rel="canonical" href="https://www.opentoworkremote.com/post" />
                </Helmet>

                <Header />

                <div className="promo-banner d-none" id="promoBanner">
                    <span 
                        className="promo-icon" 
                        role="img" 
                        aria-label="celebration"
                    >
                        🎉
                    </span>
                    <p>Special Launch Offer: Get 50% off any plan with code <strong>EARLYSPONSORSHIP</strong></p>
                    <button 
                        className="promo-close"
                        onClick={() => document.getElementById('promoBanner').style.display = 'none'}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="pricing-container" style={{
                    paddingTop: '4rem'
                }}>
                    <h1 className="pricing-title">Job Posting Options</h1>
                    <p className="pricing-subtitle">Choose your preferred job posting option</p>
                    
                    <div className="pricing-cards">
                        {this.plans.map((plan) => (
                            <div 
                                key={plan.id} 
                                className="pricing-card"
                            >
                                <h2 className="plan-name">{plan.name}</h2>
                                <div className="plan-price-container">
                                    <div className="plan-price-amount">
                                        <span className="currency">$</span>
                                        {plan.price}
                                    </div>
                                    <div className="plan-price-duration">
                                        one-time payment
                                    </div>
                                </div>
                                <ul className="features-list">
                                    {plan.features.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                                <button 
                                    className="select-plan-btn"
                                    onClick={() => this.handleSelectPlan(plan.id)}
                                >
                                    Publish Job
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="faq-section">
                    <h2>Frequently Asked Questions</h2>
                    <div className="faq-grid">
                        <div className="faq-item">
                            <h3>How do I post a job?</h3>
                            <p>Simply select your preferred option (Simple or Featured), complete the one-time payment, and provide us with your job listing URL. We'll handle the rest and publish your job within 24 hours or less. Our team ensures your job posting is properly formatted and optimized for our platform.</p>
                        </div>
                        <div className="faq-item">
                            <h3>What do I need to provide for my job posting?</h3>
                            <p>All you need to provide is the URL of your existing job description. Once received, our team will automatically process and publish your job posting across our platform and promotional channels within 24 hours.</p>
                        </div>
                        <div className="faq-item">
                            <h3>Where will my job be promoted?</h3>
                            <p>All jobs are promoted across multiple channels including LinkedIn, Twitter/X, Telegram, Discord server, Facebook, and our GitHub repository to maximize visibility to potential candidates.</p>
                        </div>
                        <div className="faq-item">
                            <h3>What's the difference between Simple and Featured jobs?</h3>
                            <p>Featured jobs get premium placement with a sticky position at the top of our home page, special color highlighting, and priority in search results.</p>
                        </div>
                        <div className="faq-item">
                            <h3>What payment methods do you accept?</h3>
                            <p>We accept all major credit cards (Visa, MasterCard, American Express) and PayPal. All payments are processed securely through our platform.</p>
                        </div>
                        <div className="faq-item">
                            <h3>How long will my job posting be visible?</h3>
                            <p>All job postings remain visible for 30 days from the date of publication. After this period, the listing will automatically expire but you can always post a new job listing.</p>
                        </div>
                    </div>
                </div>

                <div className="guarantees-section">
                    <div className="guarantee-card">
                        <div className="guarantee-icon">
                            <i className="fa fa-rocket"></i>
                        </div>
                        <h3>Fast Publication</h3>
                        <p>Your job will be live within 24 hours after submission</p>
                    </div>
                    <div className="guarantee-card">
                        <div className="guarantee-icon">
                            <i className="fa fa-lock"></i>
                        </div>
                        <h3>Secure Payments</h3>
                        <p>Your payment information is always protected</p>
                    </div>
                    <div className="guarantee-card">
                        <div className="guarantee-icon">
                            <i className="fa fa-envelope"></i>
                        </div>
                        <h3>Email Support</h3>
                        <p>Get assistance whenever you need it</p>
                    </div>
                </div>

                <div className="stats-section">
                    <div className="stats-container">
                        <div className="stat-card">
                            <span className="stat-number">20K+</span>
                            <span className="stat-label">Monthly Visitors</span>
                        </div>
                        <div className="stat-card">
                            <span className="stat-number">50K+</span>
                            <span className="stat-label">Page Views</span>
                        </div>
                        <div className="stat-card">
                            <span className="stat-number">24h</span>
                            <span className="stat-label">Jobs Online in 24h or Less</span>
                        </div>
                    </div>
                </div>

                <div className="floating-cta">
                    <div className="cta-content">
                        <h3>Ready to find your perfect remote candidate?</h3>
                        <p>Start posting jobs today and reach thousands of qualified candidates</p>
                        <button 
                            className="cta-button"
                            onClick={this.scrollToPlans}
                        >
                            Get Started Now
                            <i className="fa fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </>
        );
    }
}

export default PostJob;
